import BigText from './big-text-component';
export default BigText;
